module.exports = __webpack_public_path__ + "img/emptyContacts.ecf07167.svg";